export const UPDATE_LAYOUT_HEIGHTS = "[LAYOUT] UPDATE_LAYOUT_HEIGHTS";
export const SET_LAYOUT_WITH_PROMPT = "[LAYOUT] SET_LAYOUT_WITH_PROMPT";

export interface LayoutState {
  headerHeight: number;
  footerHeight: number;
  primaryNavigationHeight: number;
  staticNotificationHeight: number;
  eulaHeaderHeight: number;
  eulaFooterHeight: number;
  isWithPrompt: boolean;
}

export interface UpdateLayoutHeightsAction {
  type: typeof UPDATE_LAYOUT_HEIGHTS;
  payload: Partial<LayoutState>;
}

interface SetLayoutWithPromptAction {
  type: typeof SET_LAYOUT_WITH_PROMPT;
  payload: boolean;
}

export type LayoutActionTypes =
  | SetLayoutWithPromptAction
  | UpdateLayoutHeightsAction;
